module.exports = __webpack_public_path__ + "static/img/pic_biaozhi@2x.61fc639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/pic_biaozhi@2x.png
// module id = aSdD
// module chunks = 0